import { render, staticRenderFns } from "./RoomsMobile.vue?vue&type=template&id=10a129d7&scoped=true&"
import script from "./RoomsMobile.vue?vue&type=script&lang=js&"
export * from "./RoomsMobile.vue?vue&type=script&lang=js&"
import style0 from "./RoomsMobile.vue?vue&type=style&index=0&id=10a129d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a129d7",
  null
  
)

export default component.exports